<template>
	<div>
		<h1 class="page-header"><i class="fa fa-screwdriver-wrench"></i> Under construction<small></small></h1>
		<div class="row p-5 bg-white">
			<NoRecords  main_icon="fa fa-screwdriver-wrench" value="false" title="This page is under construction" subtitle="Please return later"></NoRecords>
		</div>
	</div>
</template>

<script>
	import NoRecords from '../components/NoRecords';
	export default {
		components:{
			NoRecords
		},
	};
</script>